var _circle, _circle2, _circle3, _circle4, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 28,
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 20,
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 12,
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 4,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 4L32 12M32 52L32 60M4 32L12 32M52 32L60 32",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "targetGrad",
    x1: 4,
    y1: 4,
    x2: 60,
    y2: 60
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#667eea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#764ba2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.91f9f7037e43a21c5f95a2330d0d53a3.svg";
export { ForwardRef as ReactComponent };